import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vl-loader',
  template: `<img src="/veloce-logo.svg" />`,
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {}
